































import Vue, {PropType} from "vue";
import moment from "moment";
import {mapGetters} from "vuex";
import { VenueData } from "@/types";

export default Vue.extend({
  name: "user-access-rights-table-item",

  components: {
  },

  props: {
    venue: Object as PropType<object>
  },

  computed: {
  },

  methods: {
    statusClass(status: number): string {
      if (status === 1) return "active";
      if (status === 2) return "deactivated";
    },
    statusName(value: number): string {
      if (value === 1) return this.$t("Active");
      if (value === 2) return this.$t("Deactivated");
    },
    typeClass(type: string): string {
      if (type === 'basic') return "basic";
      if (type === 'premium') return "premium";
    },
    typeName(value: string): string {
      if (value === 'basic') return this.$t("Basic");
      if (value === 'premium') return this.$t("Premium");
    },
    convertToDate(unixTimestamp: number){
        return moment.unix(unixTimestamp).format("MM/DD/YYYY");
    },
  }
})
